import React, { useState } from "react";
import "./Contact_Form.css";

import { Form, Row, Col, Nav, Tab } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import Black_btn from "../../common-components/common-button/black-btn/Black_btn";
import Successfull_Lottie from "../../animtaion/Successfull_Lottie/Successfull_Lottie";

import { addFarmDealEnquiry } from "../../../utils/apis/contact-us/ContactUs";

const Form_component = ({ closeModal }) => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("Farmer");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    reset,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: "onChange",

    defaultValues: {
      enquiry_type: "Farmer",
      name: "",
      contact_no: "",
      village: "",
      city: "",
      email: "",
    },
  });

  /* ======== TAB CHANGE ======= */
  const handleTabChange = (key) => {
    setActiveTab(key);

    setValue("enquiry_type", key);

    // Clear dealer email validation/errors when switching to Farmer
    if (key === "Farmer") {
      setValue("email", "");
      clearErrors("email");
    }
  };

  /* =========================
     SUBMIT
  ========================= */
  const onSubmit = async (data) => {
    setIsSubmitting(true);

    try {
      const submitData = {
        enquiry_type: activeTab,
        name: data.name?.trim(),
        contact_no: data.contact_no,
        village: data.village?.trim(),
        city: data.city?.trim(),
        email: activeTab === "Dealer" ? data.email?.trim() : null,
      };

      const contactResponse = await addFarmDealEnquiry(submitData);

      if (!contactResponse?.success) {
        console.error("Failed to save Farmer/dealer enquiry");
        return;
      }

      reset({
        enquiry_type: "Farmer",
        name: "",
        contact_no: "",
        village: "",
        city: "",
        email: "",
      });

      setActiveTab("Farmer");
      setFormSubmitted(true);

      setTimeout(() => {
        if (closeModal) {
          closeModal();
        } else {
          setFormSubmitted(false);
        }
      }, 3000);
      
    } catch (error) {
      console.error("Submission error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleTextInput = (e, fieldName) => {
    let value = e.target.value;

    // Allow only alphabets and spaces
    value = value.replace(/[^a-zA-Z\s]/g, "");

    // Prevent multiple spaces
    value = value.replace(/\s{2,}/g, " ");

    // Remove leading space
    value = value.replace(/^\s+/, "");

    setValue(fieldName, value, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  return (
    <>
      {!formSubmitted ? (
        <div className="dealer_form_box">
          <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
            {/* =========================
                TABS
            ========================= */}
            <Nav className="dealer_nav">
              <Nav.Item>
                <Nav.Link eventKey="Farmer">Farmer</Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="Dealer">Dealer</Nav.Link>
              </Nav.Item>
            </Nav>

            {/* ========= FORM =========== */}
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Tab.Content className="dealer_tab_content">
                {/* ============ Farmer ================ */}
                <Tab.Pane eventKey="Farmer">
                  <div className="form_title"></div>

                  <Row>
                    {/* NAME */}
                    <Col md={6}>
                      <Form.Group className="form_group">
                        <Form.Label>
                          Full Name <span>*</span>
                        </Form.Label>

                        <Form.Control
                          type="text"
                          placeholder="Enter full name"
                          {...register("name", {
                            required: "Full name is required",

                            validate: (value) => {
                              const name = value?.trim();

                              if (!name) {
                                return "Full name is required";
                              }

                              if (name.length < 2) {
                                return "Name must be at least 2 characters";
                              }

                              if (name.length > 100) {
                                return "Name cannot exceed 100 characters";
                              }

                              return true;
                            },

                            onChange: (e) => {
                              handleTextInput(e, "name");
                            },
                          })}
                          className={classNames({
                            "is-invalid": errors?.name,
                            "is-valid": getValues("name") && !errors?.name,
                          })}
                        />

                        {errors?.name && (
                          <span className="invalid-feedback d-block">
                            {errors.name.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    {/* CONTACT NUMBER */}
                    <Col md={6}>
                      <Form.Group className="form_group">
                        <Form.Label>
                          Mobile Number <span>*</span>
                        </Form.Label>

                        <Controller
                          name="contact_no"
                          control={control}
                          rules={{
                            required: "Mobile number is required",

                            validate: (value) => {
                              if (!value) {
                                return "Mobile number is required";
                              }

                              // Remove everything except numbers
                              const digits = value.replace(/\D/g, "");

                              // Remove India country code 91
                              const mobileNumber = digits.startsWith("91")
                                ? digits.slice(2)
                                : digits;

                              if (mobileNumber.length !== 10) {
                                return "Enter a valid 10-digit mobile number";
                              }

                              // First digit should be 6-9 for Indian mobile numbers
                              if (!/^[6-9]\d{9}$/.test(mobileNumber)) {
                                return "Enter a valid 10-digit mobile number";
                              }

                              return true;
                            },
                          }}
                          render={({ field }) => (
                            <PhoneInput
                              country="in"
                              value={field.value}
                              onChange={(value) => {
                                field.onChange(value);
                              }}
                              countryCodeEditable={false}
                              disableDropdown={false}
                              inputClass={classNames({
                                "is-invalid": errors?.contact_no,
                                "is-valid":
                                  getValues("contact_no") &&
                                  !errors?.contact_no,
                              })}
                              inputStyle={{
                                width: "100%",
                              }}
                              placeholder="Enter mobile number"
                              inputProps={{
                                inputMode: "numeric",
                              }}
                            />
                          )}
                        />

                        {errors?.contact_no && (
                          <span className="invalid-feedback d-block">
                            {errors.contact_no.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    {/* VILLAGE */}
                    <Col md={6}>
                      <Form.Group className="form_group">
                        <Form.Label>
                          Village <span>*</span>
                        </Form.Label>

                        <Form.Control
                          type="text"
                          placeholder="Enter village"
                          {...register("village", {
                            required: "Village is required",

                            validate: (value) => {
                              const village = value?.trim();

                              if (!village) {
                                return "Village is required";
                              }

                              if (village.length < 2) {
                                return "Village must be at least 2 characters";
                              }

                              if (village.length > 100) {
                                return "Village cannot exceed 100 characters";
                              }

                              return true;
                            },

                            onChange: (e) => {
                              handleTextInput(e, "village");
                            },
                          })}
                          className={classNames({
                            "is-invalid": errors?.village,
                            "is-valid":
                              getValues("village") && !errors?.village,
                          })}
                        />

                        {errors?.village && (
                          <span className="invalid-feedback d-block">
                            {errors.village.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    {/* CITY */}
                    <Col md={6}>
                      <Form.Group className="form_group">
                        <Form.Label>
                          City <span>*</span>
                        </Form.Label>

                        <Form.Control
                          type="text"
                          placeholder="Enter city"
                          {...register("city", {
                            required: "City is required",

                            validate: (value) => {
                              const city = value?.trim();

                              if (!city) {
                                return "City is required";
                              }

                              if (city.length < 2) {
                                return "City must be at least 2 characters";
                              }

                              if (city.length > 100) {
                                return "City cannot exceed 100 characters";
                              }

                              return true;
                            },

                            onChange: (e) => {
                              handleTextInput(e, "city");
                            },
                          })}
                          className={classNames({
                            "is-invalid": errors?.city,
                            "is-valid": getValues("city") && !errors?.city,
                          })}
                        />

                        {errors?.city && (
                          <span className="invalid-feedback d-block">
                            {errors.city.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* SUBMIT */}
                  <div className="send_btn_div">
                    <Black_btn
                      btn_name={isSubmitting ? "Submitting..." : "Submit"}
                      type="submit"
                    />
                  </div>
                </Tab.Pane>

                {/* =================== DEALER ====================== */}
                <Tab.Pane eventKey="Dealer">
                  <div className="form_title"></div>

                  <Row>
                    {/* NAME */}
                    <Col md={6}>
                      <Form.Group className="form_group">
                        <Form.Label>
                          Full Name <span>*</span>
                        </Form.Label>

                        <Form.Control
                          type="text"
                          placeholder="Enter full name"
                          {...register("name", {
                            required: "Full name is required",

                            validate: (value) => {
                              const name = value?.trim();

                              if (!name) {
                                return "Full name is required";
                              }

                              if (name.length < 2) {
                                return "Name must be at least 2 characters";
                              }

                              if (name.length > 100) {
                                return "Name cannot exceed 100 characters";
                              }

                              return true;
                            },

                            onChange: (e) => {
                              handleTextInput(e, "name");
                            },
                          })}
                          className={classNames({
                            "is-invalid": errors?.name,
                            "is-valid": getValues("name") && !errors?.name,
                          })}
                        />

                        {errors?.name && (
                          <span className="invalid-feedback d-block">
                            {errors.name.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    {/* CONTACT NUMBER */}
                    <Col md={6}>
                      <Form.Group className="form_group">
                        <Form.Label>
                          Mobile Number <span>*</span>
                        </Form.Label>

                        <Controller
                          name="contact_no"
                          control={control}
                          rules={{
                            required: "Mobile number is required",

                            validate: (value) => {
                              if (!value) {
                                return "Mobile number is required";
                              }

                              // Remove everything except numbers
                              const digits = value.replace(/\D/g, "");

                              // Remove India country code 91
                              const mobileNumber = digits.startsWith("91")
                                ? digits.slice(2)
                                : digits;

                              if (mobileNumber.length !== 10) {
                                return "Enter a valid 10-digit mobile number";
                              }

                              // First digit should be 6-9 for Indian mobile numbers
                              if (!/^[6-9]\d{9}$/.test(mobileNumber)) {
                                return "Enter a valid 10-digit mobile number";
                              }

                              return true;
                            },
                          }}
                          render={({ field }) => (
                            <PhoneInput
                              country="in"
                              value={field.value}
                              onChange={(value) => {
                                field.onChange(value);
                              }}
                              countryCodeEditable={false}
                              disableDropdown={false}
                              inputClass={classNames({
                                "is-invalid": errors?.contact_no,
                                "is-valid":
                                  getValues("contact_no") &&
                                  !errors?.contact_no,
                              })}
                              inputStyle={{
                                width: "100%",
                              }}
                              placeholder="Enter mobile number"
                              inputProps={{
                                inputMode: "numeric",
                              }}
                            />
                          )}
                        />

                        {errors?.contact_no && (
                          <span className="invalid-feedback d-block">
                            {errors.contact_no.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    {/* VILLAGE */}
                    <Col md={6}>
                      <Form.Group className="form_group">
                        <Form.Label>
                          Village <span>*</span>
                        </Form.Label>

                        <Form.Control
                          type="text"
                          placeholder="Enter village"
                          {...register("village", {
                            required: "Village is required",

                            validate: (value) => {
                              const village = value?.trim();

                              if (!village) {
                                return "Village is required";
                              }

                              if (village.length < 2) {
                                return "Village must be at least 2 characters";
                              }

                              if (village.length > 100) {
                                return "Village cannot exceed 100 characters";
                              }

                              return true;
                            },

                            onChange: (e) => {
                              handleTextInput(e, "village");
                            },
                          })}
                          className={classNames({
                            "is-invalid": errors?.village,
                            "is-valid":
                              getValues("village") && !errors?.village,
                          })}
                        />

                        {errors?.village && (
                          <span className="invalid-feedback d-block">
                            {errors.village.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    {/* CITY */}
                    <Col md={6}>
                      <Form.Group className="form_group">
                        <Form.Label>
                          City <span>*</span>
                        </Form.Label>

                        <Form.Control
                          type="text"
                          placeholder="Enter city"
                          {...register("city", {
                            required: "City is required",

                            validate: (value) => {
                              const city = value?.trim();

                              if (!city) {
                                return "City is required";
                              }

                              if (city.length < 2) {
                                return "City must be at least 2 characters";
                              }

                              if (city.length > 100) {
                                return "City cannot exceed 100 characters";
                              }

                              return true;
                            },

                            onChange: (e) => {
                              handleTextInput(e, "city");
                            },
                          })}
                          className={classNames({
                            "is-invalid": errors?.city,
                            "is-valid": getValues("city") && !errors?.city,
                          })}
                        />

                        {errors?.city && (
                          <span className="invalid-feedback d-block">
                            {errors.city.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    {/* EMAIL - DEALER ONLY */}
                    <Col md={6}>
                      <Form.Group className="form_group">
                        <Form.Label>
                          Email <span>*</span>
                        </Form.Label>

                        <Form.Control
                          type="email"
                          placeholder="Enter email address"
                          {...register("email", {
                            required:
                              activeTab === "Dealer"
                                ? "Email is required"
                                : false,

                            validate: (value) => {
                              if (!value && activeTab === "Dealer") {
                                return "Email is required";
                              }

                              if (!value) {
                                return true;
                              }

                              const email = value.trim();

                              if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                                return "Enter a valid email address";
                              }

                              if (email.length > 150) {
                                return "Email cannot exceed 150 characters";
                              }

                              return true;
                            },
                          })}
                          className={classNames({
                            "is-invalid": errors?.email,
                            "is-valid": getValues("email") && !errors?.email,
                          })}
                        />

                        {errors?.email && (
                          <span className="invalid-feedback d-block">
                            {errors.email.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* SUBMIT */}
                  <div className="send_btn_div">
                    <Black_btn
                      btn_name={isSubmitting ? "Submitting..." : "Submit"}
                      type="submit"
                    />
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Form>
          </Tab.Container>
        </div>
      ) : (
        <div className="success_div">
          <Successfull_Lottie successText="Form Submitted Successfully" />
        </div>
      )}
    </>
  );
};

export default Form_component;
